import { defineAction, object, number } from '~/prix'
import fetchStreetsAndWays from './fetchStreetsAndWays.action.json' with { type: 'json' }

const fetchStreetsAndWaysDefinition = defineAction({
  ...fetchStreetsAndWays,
  input: object({
    cityIbgeCode: number().label('Código IBGE da cidade.'),
  }),
  output: object({}),
})

export default fetchStreetsAndWaysDefinition
